import { onBeforeUnmount, onMounted } from "vue";

// Browsers commonly emit both visibilitychange and focus on a single resume.
export function useResumeRefresh(enabled: () => boolean, refresh: () => Promise<void>) {
  let timer: number | undefined;
  let refreshing = false;
  function schedule() {
    window.clearTimeout(timer);
    if (document.visibilityState !== "visible" || !enabled() || refreshing) return;
    timer = window.setTimeout(async () => {
      if (document.visibilityState !== "visible" || !enabled()) return;
      refreshing = true;
      try { await refresh(); }
      finally { refreshing = false; }
    }, 200);
  }
  onMounted(() => {
    window.addEventListener("focus", schedule);
    document.addEventListener("visibilitychange", schedule);
  });
  onBeforeUnmount(() => {
    window.clearTimeout(timer);
    window.removeEventListener("focus", schedule);
    document.removeEventListener("visibilitychange", schedule);
  });
}
